import MDBox from "@/components/atoms/MDBox";
import ChatHistory from "@/components/screens/Chat/components/CurrentChat/ChatHistory";
import useContactData from "@/hooks/data/use-contact-data";
import IContact from "@/interfaces/contact.interface";
import { ChatMessages } from "@/messages/chat/chat.messages";

type ChatSectionProps = {
  messages: ChatMessages;
  contact: IContact;
};

export default function ChatSection({ messages, contact }: ChatSectionProps) {
  const { fullName } = useContactData({ contact, messages });

  return (
    <MDBox mt={2}>
      <ChatHistory contactId={contact.id} contactName={fullName!} messages={messages} />
    </MDBox>
  );
}
